// Trang thai co TaskGov:Enabled (qlvb-be GET /qlvb/taskgov/cau-hinh) dung chung cho menu va router guard,
// de tat co thi an han muc "Tich hop TaskGov" (route co meta.taskGov). GiaoViecTaskGov, DanhSachVanBanDen,
// LichSuGiaoViecTaskGov van tu goi cau-hinh rieng.
// Ket qua nho trong ca phien trang: doi co tren BE thi nguoi dung tai lai trang moi thay.
import Vue from "vue";
import { callApiLayCauHinhTaskGov } from "@/api/taskgov";

// Mac dinh tat: chua tai xong hoac loi thi coi nhu tat (an menu, chan route).
export const trangThaiCauHinhTaskGov = Vue.observable({ enabled: false });

// Interceptor 401 (utils/http-configs.js) co the de promise treo mai; guard cho vo han se ket dieu huong.
const THOI_GIAN_CHO_TOI_DA_MS = 10000;

let lanTaiDangCho = null;
let daTaiThanhCong = false;

/**
 * Tai co mot lan moi phien trang. Chi nho ket qua khi goi thanh cong; loi hoac qua thoi gian cho
 * (vd chua dang nhap, mat mang, 401) thi lan sau goi lai. Khong bao gio nem loi.
 * @returns {Promise<boolean>} co dang bat hay khong
 */
export function taiCauHinhTaskGov() {
  if (daTaiThanhCong) return Promise.resolve(trangThaiCauHinhTaskGov.enabled);
  if (lanTaiDangCho) return lanTaiDangCho;
  const quaHan = new Promise((resolve) => setTimeout(() => resolve(null), THOI_GIAN_CHO_TOI_DA_MS));
  lanTaiDangCho = Promise.race([callApiLayCauHinhTaskGov(), quaHan])
    .then((res) => {
      const data = res && res.data && res.data.IsSuccess ? res.data.Data : null;
      trangThaiCauHinhTaskGov.enabled = !!(data && data.Enabled);
      daTaiThanhCong = !!data;
      return trangThaiCauHinhTaskGov.enabled;
    })
    .catch(() => {
      trangThaiCauHinhTaskGov.enabled = false;
      return false;
    })
    .finally(() => {
      lanTaiDangCho = null;
    });
  return lanTaiDangCho;
}

/** Route thuoc tich hop TaskGov (danh dau meta.taskGov trong router). */
export function laRouteTaskGov(route) {
  return !!(route && route.meta && route.meta.taskGov);
}

/** true khi route thuoc TaskGov ma co chua bat -> an khoi menu. */
export function anRouteTaskGov(route) {
  return laRouteTaskGov(route) && !trangThaiCauHinhTaskGov.enabled;
}
